module.exports = __webpack_public_path__ + "img/zhiwu.61c7ebec.png";